import { EstudianteActivoDTO } from "../SAAC/EstudianteActivoDTO";
import { PeriodoAcademicoDTO } from "../SAAC/PeriodoAcademicoDTO";
import { SolicitudAyudanteInv } from "./SolicitudAyudanteInv";
import { TblDecInvProyectoAyud, VoidTblDecInvProyectoAyud } from "./TblDecInvProyectoAyud";
import { TblDetalleSolicitudAyud, VoidTblDetalleSolicitudAyud } from "./TblDetalleSolicitudAyud";
import { TblGestionSolicitudAyud } from "./TblGestionSolicitudAyud";
import { TblSolicitudAyud, VoidTblSolicitudAyud } from "./TblSolicitudAyud";

export interface AyudantiaInvestigacion{
    codigoProyecto: string,
    tituloProyecto: string,
    estudiante: string,
    proyectoAyud: TblDecInvProyectoAyud,
    solicitudAyudCab: TblSolicitudAyud,
    detalle: TblDetalleSolicitudAyud,
    gestion: Array<TblGestionSolicitudAyud>,
}

export function VoidAyudantiaInvestigacion(): AyudantiaInvestigacion{
    return{
        codigoProyecto: '',
        tituloProyecto: '',
        estudiante: '',
        proyectoAyud: VoidTblDecInvProyectoAyud(),
        solicitudAyudCab: VoidTblSolicitudAyud(),
        detalle: VoidTblDetalleSolicitudAyud(),
        gestion: [],
    }   
}

export function CastSolicitudAyudanteInvToAyudantiaInvestigacion(ayudantia: AyudantiaInvestigacion,values: SolicitudAyudanteInv,periodo: PeriodoAcademicoDTO,idproyecto: number,estudiante: EstudianteActivoDTO):AyudantiaInvestigacion{
    let objeto = ayudantia;
    //ProyectoAyud
    objeto.proyectoAyud.iddecinvproyecto = idproyecto;
    objeto.proyectoAyud.codEstudiante = estudiante.matricula;
    objeto.proyectoAyud.descripcion = values.descripcion;
    objeto.proyectoAyud.termino = periodo.termino;
    objeto.proyectoAyud.anio = periodo.anio;
    objeto.proyectoAyud.horas = parseInt(values.horas ?? '0', 10);
    objeto.proyectoAyud.actividades = values.actividades;
    objeto.proyectoAyud.estado = 'R';    
    objeto.proyectoAyud.financiamientoayudante = parseInt(values.tipofinanciamiento?? '0', 10);
    objeto.proyectoAyud.mailresponsable = values.docente;
    objeto.proyectoAyud.fechasolicitud = new Date(Date.UTC(
        new Date().getUTCFullYear(),
        new Date().getUTCMonth(),
        new Date().getUTCDate()
      ));
    objeto.proyectoAyud.ultimocambio = new Date(Date.UTC(
        new Date().getUTCFullYear(),
        new Date().getUTCMonth(),
        new Date().getUTCDate()
      ));
    //Solicitud
    objeto.solicitudAyudCab.idperiodo = periodo.idperiodo;
    objeto.solicitudAyudCab.idestudiante = estudiante.idpersona;
    objeto.solicitudAyudCab.codestudiante = estudiante.matricula;
    objeto.solicitudAyudCab.observacion = 'Generado desde el portal de investigación';
    objeto.solicitudAyudCab.tipo = 'I';
    objeto.solicitudAyudCab.estado = 'A';
    objeto.solicitudAyudCab.limitehoraayud = parseInt(values.horas ?? '0', 10);
    objeto.solicitudAyudCab.esadhonorem = objeto.proyectoAyud.financiamientoayudante === 2 ? 'S' : 'N'
    objeto.solicitudAyudCab.fechasolicitud = new Date(Date.UTC(
        new Date().getUTCFullYear(),
        new Date().getUTCMonth(),
        new Date().getUTCDate()
      ));
    objeto.solicitudAyudCab.ultimocambio = new Date(Date.UTC(
        new Date().getUTCFullYear(),
        new Date().getUTCMonth(),
        new Date().getUTCDate()
      ));
    //Detalle
    objeto.detalle.idunidad = 15267;
    objeto.detalle.numhoras = parseInt(values.horas ?? '0', 10);
    objeto.detalle.tipo = 'I';
    objeto.detalle.estado = 'P';
    objeto.detalle.numayudantias = objeto.detalle.numhoras === 5 ? 1 : 2;
    objeto.detalle.numayudantiasotorgadas = 0;
    objeto.detalle.numhorasotorgadas = 0;
    objeto.detalle.esadhonorem = objeto.proyectoAyud.financiamientoayudante === 2 ? 'S' : 'N'
    objeto.detalle.ultimocambio = new Date(Date.UTC(
        new Date().getUTCFullYear(),
        new Date().getUTCMonth(),
        new Date().getUTCDate()
      ));
    console.log(objeto);
    return objeto;
}